import React, { useContext } from 'react';

import { RangeSlider, RangeValues } from '@zooplus/ui-components';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import FiltersContext from '../../contexts/FiltersContext';

export const ZooPointsSlider = () => {
  const { onFormatLocale } = useContext(LocResourcesContext);
  const { maxPoints, minValue, maxValue, onSetMinValue, onSetMaxValue } =
    useContext(FiltersContext);

  return (
    <>
      <label htmlFor="zooPoints-slider" className="filtersSliderLabel">
        {onFormatLocale?.('bp.points')}
      </label>
      <RangeSlider
        id="zooPoints-slider"
        className="rangeSlider"
        boundaryValues={{
          high: maxPoints ?? 0,
          low: 0,
        }}
        value={{ low: minValue ?? 0, high: maxValue ?? 0 }}
        onValueChange={(values: RangeValues) => {
          onSetMinValue?.(values.low);
          onSetMaxValue?.(values.high);
        }}
        outputDebounceTime={600}
        rangeInputHighAriaLabel={
          onFormatLocale ? onFormatLocale('loy.rewards.shop.filter.sliderRangeHigh') : ''
        }
        rangeInputLowAriaLabel={
          onFormatLocale ? onFormatLocale('loy.rewards.shop.filter.sliderRangeLow') : ''
        }
      />
    </>
  );
};
